<template>
  <div style="width: 100%; height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.suName" style="width: 140px;" size="mini" placeholder="请输入用户姓名"
            clearable></el-input>
          <el-input v-model="formDatas.suAccount" style="width: 140px;" size="mini" placeholder="请输入用户账号"
            clearable></el-input>
          <el-select v-model="formDatas.suPost" placeholder="岗位" size="mini" style="width: 140px;" clearable filterable @change="partserch">
            <el-option label="管理员" :value="1"></el-option>
            <el-option label="用户" :value="2"></el-option>
          </el-select>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <el-button type="success" size="mini" style="margin-right: 20px" @click="
            dialog = true;
          edit = false;
          ">新增用户</el-button>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%" :max-height="tableHight"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            textAlign: 'center',
            background: 'rgba(0,170,255,0.5)',
            color: 'black',
            border: 'none',
          }">
          <!-- @selection-change="handleSelectionChange" -->
          <!--  <el-table-column type="selection" width="55" >
          </el-table-column> -->

          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column prop="suAccount" label="用户账号"> </el-table-column>
          <el-table-column prop="suName" label="用户姓名"> </el-table-column>
          <el-table-column prop="suEmail" label="邮箱"> </el-table-column>
          <el-table-column prop="suPhoneDingtalk" label="钉钉手机号" width="160"> </el-table-column>
          <el-table-column prop="suPostName" label="用户岗位" width="160">
            <template slot-scope="scope">
              <el-tag size="mini" type="primary" disable-transitions>{{
                scope.row.suPostName
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="suPostName" label="用户角色" width="220">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.suRoleNames" size="mini" type="primary" disable-transitions>{{
                scope.row.suRoleNames
              }}</el-tag>

            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" width="160">
          </el-table-column>
          <el-table-column prop="dmDelete" label="用户状态" width="140">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.dmDelete == 2 ? 'danger' : 'success'" disable-transitions>{{
                scope.row.dmDelete == 2 ? "已删除" : "在使用" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="text" @click="handleDel(scope.row.suId)" style="color: red">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 100%;height: 60px">
        <div style="width: 100%;height: 100%;margin-top: 10px;">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :page-sizes="[20, 50, 80, 100, 300, 500, 1000]" background layout="total,sizes,prev, pager, next "
            :page-size="20" :total="totals" :current-page="currentPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-drawer :title="edit == true ? '编辑用户' : '新增用户'" :wrapperClosable="false" :before-close="handleClose"
      :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content" style="padding: 50px">
        <el-form :model="form" label-position="top" :rules="rules">
          <el-form-item label="用户账号" label-width="100" prop="suAccount">
            <el-input v-model="form.suAccount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户名称" label-width="100" prop="suName">
            <el-input v-model="form.suName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户角色" label-width="100" prop="suRoleIds">
            <el-select v-model="form.suRoleIds" placeholder="请选择角色" clearable filterable multiple>
              <el-option v-for="(item, index) in userAuth || []" :key="item.roleId" :label="item.roleName"
                :value="item.roleId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户岗位" label-width="100" prop="suPost">
            <el-select v-model.number="form.suPost" placeholder="请选择岗位" :disabled="edit == true">
              <el-option label="管理员" :value="1"></el-option>
              <el-option label="用户" :value="2"></el-option>
              <el-option label="证书查看" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="钉钉手机号" label-width="100">
            <el-input v-model="form.suPhoneDingtalk" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户邮箱" label-width="100">
            <el-input v-model="form.suEmail" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户密码" label-width="100">
            <el-input v-model="form.suPw" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="用户描述" label-width="100">
          <el-input v-model="form.suDes" autocomplete="off"></el-input>
        </el-form-item> -->
        </el-form>
        <div class="demo-drawer__footer" style="margin-top: 50px">
          <el-button @click="cancelForm" style="margin-left: 50px">取 消</el-button>
          <el-button type="primary" @click="open" :loading="loading" style="margin-left: 150px">{{ loading ? "提交中 ..." :
            "确 定" }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import qs from "qs";
// import api from "../../utils/api";
import {
  deleteSysUser,
  addSysUser,
  getSysUserList,
  updateSysUser,
  getAyRoleList,
} from "../../api/api";
import { number } from "echarts";
export default {
  name: "userList",
  data() {
    return {
      userAuth: [],
      atidsArr: [],
      currentPage: 1,
      tableHight: 720,
      watchFlag: false,
      windheight: "",
      tableData: [],
      dialog: false, //弹框
      loading: false,
      timer: null,
      form: {
        suPhoneDingtalk: '',
        suAccount: "",
        suName: '',
        suPost: null,
        suRoleIds: '',
        suPw: "",
        suDes: "",
        suEmail: "",
      },
      formDatas: {
        currentPage: 1,
        pageSize: 20,
      },
      diashow: false, //关闭
      rules: {
        suAccount: [
          {
            required: true,
            message: "请输入用户账号",
            trigger: "blur",
          },
        ],
        suPost: [
          {
            required: true,
            message: "请选择岗位",
            trigger: "change",
          },
        ],
      },
      edit: false, //编辑时
      totals: null,
    };
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  methods: {
    partserch() {
      this.formDatas.currentPage = 1;
      const s = qs.stringify(this.formDatas);
      getSysUserList(s).then((res) => {
        this.tableData = res.data;
        this.totals = res.total;
        // this.$message({
        //     type: "success",
        //     message: "搜索成功!",
        // });
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.formDatas.pageSize = val;
      this.getSysUserListUser()
    },
    // 分页跳转
    async handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.formDatas.currentPage = val;
      const s = qs.stringify(this.formDatas)

      await getSysUserList(s).then(res => {
        this.totals = res.total
        this.tableData = res.data
        this.$nextTick(() => {
          console.log('最后的ids', this.atidsArr)
          this.tableData.forEach((i, index) => {
            this.atidsArr.forEach(t => {
              if (i.suId === t.suId) {
                this.$refs.multipleTable.toggleRowSelection(i, true);
              }
            })
          })
        })
      })
    },
    handleDel(val) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const s = { suIds: val };
          deleteSysUser(s).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getSysUserListUser();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑
    handleEdit(index, row) {
      console.log(index, row);
      this.edit = true;
      this.dialog = true;
      this.form = JSON.parse(JSON.stringify(row));
      this.form.suRoleIds = row.suRoleIds.split(",").map(Number);
    },
    // 删除
    handleDelete(index, row) {
      console.log(index, row);
    },
    // 获取列表
    getSysUserListUser() {
      this.$nextTick(() => {
        getSysUserList().then((res) => {
          this.tableData = res.data;
          this.totals = res.total
        });
      });
    },
    open() {
      if (this.form.suAccount == "" || this.form.suPost == "") {
        this.$message({
          showClose: true,
          message: "请完成表单内容",
          type: "success",
        });
      } else {
        this.diashow = true;
        this.$refs.drawer.closeDrawer();
      }
    },
    handleClose(done) {
      console.log(this.diashow);
      if (this.diashow == false) {
        this.$confirm("确认关闭？")
          .then((_) => {
            done();
          })
          .catch((_) => { });
        (this.form = {
          suEmail: "",
          suAccount: "",
          suPost: null,
          suPw: "",
          suDes: "",
        }),
          (this.edit = false);
        this.diashow = false;
      } else {
        console.log(this.diashow);
        // 表单编辑
        if (this.edit == true) {
          this.$confirm("确定要编辑用户吗？")
            .then((_) => {
              this.form.suRoleIds = this.form.suRoleIds.toString()
              const s = qs.stringify(this.form);
              updateSysUser(s).then((res) => {
                if (!res) return;
                this.getSysUserListUser();
                this.$message({
                  showClose: true,
                  message: "编辑成功",
                  type: "success",
                });
                (this.form = {
                  suEmail: "",
                  suAccount: "",
                  suPost: null,
                  suPw: "",
                  suDes: "",
                }),
                  // this.loading = true;
                  done();
                this.diashow = false;
              });

              // this.timer = setTimeout(() => {

              // 动画关闭需要一定的时间
              // setTimeout(() => {
              //   this.loading = false;
              // }, 400);
              // }, 2000)
            })
            .catch((_) => { });
        } else {
          // 表单提交
          this.$confirm("确定要提交表单吗？")
            .then((_) => {
              this.form.suRoleIds = this.form.suRoleIds.toString()
              const s = qs.stringify(this.form);
              addSysUser(s).then((res) => {
                if (!res) return;
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success",
                });
                this.getSysUserListUser();
                (this.form = {
                  suEmail: "",
                  suAccount: "",
                  suPost: null,
                  suPw: "",
                  suDes: "",
                }),
                  // this.loading = true;
                  done();
                this.diashow = false;
              });

              // this.timer = setTimeout(() => {
              //   done();
              //   // 动画关闭需要一定的时间
              //   setTimeout(() => {
              //     this.loading = false;
              //   }, 400);
              // }, 2000)
            })
            .catch((_) => { });
          this.diashow = false;
        }
      }
    },
    // 表单取消
    cancelForm() {
      (this.form = {
        suEmail: "",
        suAccount: "",
        suPost: null,
        suPw: "",
        suDes: "",
      }),
        (this.edit = false);
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      this.getSysUserListUser();
    });
  },
  async created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.getSysUserListUser();
    getAyRoleList().then(res => {
      this.userAuth = res.data
    })
  },
};
</script>

<style scoped>
div /deep/ .el-pagination__total {
  margin-right: 35%;
  margin-left: 5%;
}
</style>
